<template>
  <div id="root" style="top: 50px;">
    <my-canvas :showRes="showRes"></my-canvas>
    <!-- 展示公司logo和主题 -->
    <div style="position: absolute; width: 100%; height: 100%;">
      <div style="padding: 3vh;" class="logo">
        <!-- <img src="./assets/logo6.svg" alt="" style="width: 126px; position: relative; top: -17px;"> -->
        <img src="./assets/logo25.svg" alt="" style="width: 13vh;" />
      </div>
      <!-- <div
        style="position: absolute; top: 3%; text-align: center; width: 100%; color: red; font-size: 6vh; letter-spacing: 3px;"
      >
        贰零贰二年康桥年会
      </div> -->
    </div>
    <header style="background-color: #1A1A1A;top: -50px;">
      <Publicity v-show="!running" />
      <el-button class="res" type="text" @click="showResult = true">
        抽奖结果
      </el-button>
      <el-button class="con" type="text" @click="showConfig = true">
        抽奖配置
      </el-button>
    </header>
    <div
      id="main"
      :class="{ mask: showRes }"
      style="top: -50px; position: relative;"
    ></div>
    <div id="tags">
      <ul v-for="item in datas" :key="item.key">
        <li>
          <a
            href="javascript:void(0);"
            :style="{
              color: '#fff'
            }"
          >
            {{ item.name ? item.name : item.key }}
            <div
              ref="svgimg"
              v-if="!item.photo"
              :data-svg="item.name ? item.name : item.key"
            >
              {{ item.name ? item.name : item.key }}
            </div>
            <!-- <img v-if="!item.photo" src="./assets/星星2.png" :width="50"
                            @load="svgToImg($event, item.name ? item.name : item.key)" :height="50" /> -->
            <img v-if="item.photo" :src="item.photo" :width="50" :height="50" />
          </a>
        </li>
      </ul>
    </div>
    <transition name="bounce">
      <div id="resbox" v-show="showRes" style="top:35%">
        <p @click="showRes = false">{{ categoryName }}抽奖结果</p>
        <div class="container">
          <span
            v-for="item in resArr"
            :key="item"
            class="itemres"
            :style="resCardStyle"
            :data-id="item"
            @click="showRes = false"
            :class="{
              numberOver:
                !!photos.find(d => d.id === item) ||
                !!list.find(d => d.key === item)
            }"
          >
            <img
              src="./assets/test.svg"
              alt=""
              style="display: block; width: 69px; height: 67px; position: absolute; resize: auto; top: -71px; transform: translate(-39px, 34px) rotate(-29deg);"
            />
            <span class="cont" v-if="!photos.find(d => d.id === item)">
              <span
                v-if="!!list.find(d => d.key === item)"
                :style="{
                  fontSize: '40px'
                }"
              >
                {{ list.find(d => d.key === item).name }}
              </span>
              <span v-else>
                {{ item }}
              </span>
            </span>
            <img
              v-if="photos.find(d => d.id === item)"
              :src="photos.find(d => d.id === item).value"
              alt="photo"
              :width="160"
              :height="160"
            />
          </span>
        </div>

        <div>
          <!-- <div v-if="getPhoto_text != ''" id="text_" style="font-size: 21px;color: aqua;margin-bottom: 10px;margin-left: -22px;">{{getPhoto_text}}
          </div>
          <img  v-if="getPhoto_url != ''" :src="getPhoto_url" alt="" :width="110" :height="110" style="margin-left: -22px;" /> -->
          <div
            v-if="ppText != ''"
            id="text_"
            style="font-size: 21px;color: aliceblue;margin-bottom: 10px;margin-left: -22px;"
          >
            {{ ppText }}
          </div>
          <img
            v-if="ppfile != ''"
            :src="ppfile"
            alt=""
            :width="110"
            :height="110"
            style="margin-left: -22px;"
          />
        </div>
      </div>
    </transition>

    <el-button
      class="audio"
      type="text"
      @click="
        () => {
          playAudio(!audioPlaying);
        }
      "
    >
      <i
        class="iconfont"
        :class="[audioPlaying ? 'iconstop' : 'iconplay1']"
      ></i>
    </el-button>

    <LotteryConfig :visible.sync="showConfig" @resetconfig="reloadTagCanvas" />
    <Tool
      @toggle="toggle"
      @resetConfig="reloadTagCanvas"
      @getPhoto="getPhoto"
      :running="running"
      :closeRes="closeRes"
    />
    <Result :visible.sync="showResult"></Result>

    <span class="copy-right">
      Copyright©zhangyongfeng5350@gmail.com
    </span>

    <audio
      id="audiobg"
      preload="auto"
      controls
      autoplay
      loop
      @play="playHandler"
      @pause="pauseHandler"
    >
      <source :src="audioSrc" />
      你的浏览器不支持audio标签
    </audio>
  </div>
</template>
<script>
import LotteryConfig from '@/components/LotteryConfig';
import Publicity from '@/components/Publicity';
import Tool from '@/components/Tool';
import bgaudio from '@/assets/bg.mp3';
import beginaudio from '@/assets/begin.mp3';
import {
  clearData,
  getData,
  configField,
  resultField,
  newLotteryField,
  conversionCategoryName,
  listField
} from '@/helper/index';
import { luckydrawHandler } from '@/helper/algorithm';
import Result from '@/components/Result';
import { database, DB_STORE_NAME } from '@/helper/db';
import myCanvas from '@/components/myCanvas';
export default {
  name: 'App',

  components: {
    LotteryConfig,
    Publicity,
    Tool,
    Result,
    myCanvas
  },

  computed: {
    resCardStyle() {
      const style = {
        fontSize: '30px'
      };
      const { number } = this.config;
      if (number < 100) {
        style.fontSize = '100px';
      } else if (number < 1000) {
        style.fontSize = '80px';
      } else if (number < 10000) {
        style.fontSize = '60px';
      }
      return style;
    },
    config: {
      get() {
        return this.$store.state.config;
      }
    },
    result: {
      get() {
        return this.$store.state.result;
      },
      set(val) {
        this.$store.commit('setResult', val);
      }
    },
    list() {
      return this.$store.state.list;
    },
    allresult() {
      let allresult = [];
      for (const key in this.result) {
        if (this.result.hasOwnProperty(key)) {
          const element = this.result[key];
          allresult = allresult.concat(element);
        }
      }
      // 因为设置了展示抽奖结果的是名单，而不是序号，所以这里要把名单转换成序号，给程序排除掉已经抽掉的序号，保证了不同奖项之间抽奖也不会有重复的。
      if (this.list.length > 0) {
        let allresult_ = [];
        let this_ = this;
        allresult.forEach(function(item) {
          let val = -1;
          this_.list.forEach(function(item2) {
            if (item2.name === item) val = item2.key;
          });
          val !== -1 || allresult_.push(item);
          val === -1 || allresult_.push(val);
        });
        return allresult_;
      }
      return allresult;
    },
    datas() {
      const { number } = this.config;
      const nums = number >= 1500 ? 500 : this.config.number;
      const configNum = number > 1500 ? Math.floor(number / 3) : number;
      const randomShowNums = luckydrawHandler(configNum, [], nums);
      const randomShowDatas = randomShowNums.map(item => {
        const listData = this.list.find(d => d.key === item);
        const photo = this.photos.find(d => d.id === item);
        return {
          key: item * (number > 1500 ? 3 : 1),
          name: listData ? listData.name : '',
          photo: photo ? photo.value : ''
        };
      });
      return randomShowDatas;
    },
    categoryName() {
      return conversionCategoryName(this.category);
    },
    photos() {
      return this.$store.state.photos;
    }
  },
  created() {
    const data = getData(configField);
    if (data) {
      this.$store.commit('setConfig', Object.assign({}, data));
    }
    const result = getData(resultField);
    if (result) {
      this.$store.commit('setResult', result);
    }

    const newLottery = getData(newLotteryField);
    if (newLottery) {
      const config = this.config;
      newLottery.forEach(item => {
        this.$store.commit('setNewLottery', item);
        if (!config[item.key]) {
          this.$set(config, item.key, 0);
        }
      });
      this.$store.commit('setConfig', config);
    }

    const list = getData(listField);
    if (list) {
      this.$store.commit('setList', list);
    }

    // 重新加载就情况缓存（indexDB/本地缓存）
    // localStorage.removeItem("photo_");
    clearData();
    this.$store.commit('setClearStore');
    // setTimeout(() => {
    //     clearData();
    //     this.$store.commit('setClearStore');
    //     database.clear(DB_STORE_NAME);
    //     localStorage.removeItem("photo_");
    //     this.closeRes && this.closeRes();

    //     this.showRemoveoptions = false;

    //     this.$nextTick(() => {
    //         this.$emit('resetConfig');
    //     });
    // }, 2000);
  },

  data() {
    return {
      running: false,
      showRes: false,
      showConfig: false,
      showResult: false,
      resArr: [],
      category: '',
      audioPlaying: false,
      audioSrc: bgaudio,

      ppfile: '',
      ppText: ''
    };
  },
  watch: {
    photos: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.reloadTagCanvas();
        });
      }
    }
  },
  mounted() {
    this.startTagCanvas();
    setTimeout(() => {
      this.getPhoto();
    }, 1000);
    window.addEventListener('resize', this.reportWindowSize);
    !this.svgToImg || this.svgToImg();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reportWindowSize);
  },
  methods: {
    // 给名单加上星星图片，但是有中文的不能加。
    svgToImg() {
      var flag = true;
      this.$refs['svgimg'].forEach(function(item) {
        var reg = /[\u4e00-\u9fa5]+/g;
        var str = item.dataset['svg'];
        str.match(reg);
        reg.test(str) ? (flag = false) : '';
      });

      flag ||
        this.$refs['svgimg'].forEach(function(item) {
          item.innerHTML = '';
        });

      // var len = ['430', '320', '220', '180', '40']
      var len = ['570', '490', '390', '310', '240', '170'];
      !flag ||
        this.$refs['svgimg'].forEach(function(item) {
          // var str = item.innerText.trim()
          var str = item.dataset['svg'];
          // var len2 = str.length < 6 ? len[str.length - 1] : '0'
          var len2 = str.length <= len.length ? len[str.length - 1] : '90';

          // var svg = `<svg id="mySVGElement" t="1610440736626" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2040" width="100" height="100"> <path d="M313.991837 914.285714c-20.37551 0-40.228571-6.269388-56.946939-18.808163-30.302041-21.942857-44.930612-58.514286-38.661225-95.085714l24.032654-141.061225c3.134694-18.285714-3.134694-36.571429-16.195919-49.110204L123.297959 509.910204c-26.644898-26.122449-36.04898-64.261224-24.555102-99.787755 11.493878-35.526531 41.795918-61.126531 78.889796-66.35102l141.583674-20.375511c18.285714-2.612245 33.959184-14.106122 41.795918-30.30204l63.216326-128.522449C440.946939 130.612245 474.383673 109.714286 512 109.714286s71.053061 20.897959 87.24898 54.334694L662.987755 292.571429c8.359184 16.195918 24.032653 27.689796 41.795918 30.30204l141.583674 20.375511c37.093878 5.22449 67.395918 30.82449 78.889796 66.35102 11.493878 35.526531 2.089796 73.665306-24.555102 99.787755l-102.4 99.787755c-13.061224 12.538776-19.330612 31.346939-16.195919 49.110204l24.032654 141.061225c6.269388 37.093878-8.359184 73.142857-38.661225 95.085714-30.302041 21.942857-69.485714 24.555102-102.4 7.314286L538.122449 836.440816c-16.195918-8.359184-35.526531-8.359184-51.722449 0l-126.955102 66.87347c-14.628571 7.314286-30.302041 10.971429-45.453061 10.971428z m162.481632-96.653061z" fill="#F2CB51" p-id="2041"></path> <text x="${len2}" y="670" fill="#fff" font-size="300">${str}</text></svg>`
          var svg = `<svg t="1610503547651" class="icon" viewBox="0 0 1380 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2745" width="80" height="80"><path d="M356.173913 272.740174C376.653913 119.006609 517.209043 0 687.504696 0c169.494261 0 309.51513 117.849043 331.063652 270.558609-47.638261 88.420174-147.678609 152.175304-331.063652 152.175304-181.871304 0-282.579478-62.686609-331.330783-149.993739z" fill="#d81e06" p-id="2746"></path><path d="M690.621217 1023.955478l-6.856347 0.044522c-9.037913 0-18.387478-0.445217-28.048696-1.335652-78.402783-4.541217-204.933565-21.815652-312.631652-67.717565-319.666087-136.281043-469.25913-563.2-213.125565-635.993044 264.681739-45.145043 213.793391 133.921391 560.66226 136.236522 346.290087-2.31513 295.535304-181.381565 559.771826-136.236522 255.821913 72.793043 106.406957 499.712-212.813913 635.993044-120.386783 51.422609-264.414609 66.871652-338.098087 68.830608a135.346087 135.346087 0 0 1-2.048 0.222609l-6.811826-0.044522z" fill="#d81e06" p-id="2747"></path><text x="${len2}" y="790" fill="#FFFCA8" font-size="300">${str}</text></svg>`;
          var img = document.createElement('img');
          img.src = 'data:image/svg+xml;base64, ' + window.btoa(svg);
          item.innerHTML = str; // 清空内容
          item.appendChild(img);
        });

      // var uls = document.querySelectorAll("#tags ul")
      // document.querySelectorAll("#tags ul").forEach(function (item) {

      //     console.log(item)
      // })
      this.reloadTagCanvas();

      // var len = ['430', '320', '220', '180', '40']
      // var len2 = String(item).length < 6 ? len[String(item).length - 1] : '0'
      // console.log(typeof item)
      // var svg =
      //     `<svg id="mySVGElement" t="1610440736626" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2040" width="100" height="100"> <path d="M313.991837 914.285714c-20.37551 0-40.228571-6.269388-56.946939-18.808163-30.302041-21.942857-44.930612-58.514286-38.661225-95.085714l24.032654-141.061225c3.134694-18.285714-3.134694-36.571429-16.195919-49.110204L123.297959 509.910204c-26.644898-26.122449-36.04898-64.261224-24.555102-99.787755 11.493878-35.526531 41.795918-61.126531 78.889796-66.35102l141.583674-20.375511c18.285714-2.612245 33.959184-14.106122 41.795918-30.30204l63.216326-128.522449C440.946939 130.612245 474.383673 109.714286 512 109.714286s71.053061 20.897959 87.24898 54.334694L662.987755 292.571429c8.359184 16.195918 24.032653 27.689796 41.795918 30.30204l141.583674 20.375511c37.093878 5.22449 67.395918 30.82449 78.889796 66.35102 11.493878 35.526531 2.089796 73.665306-24.555102 99.787755l-102.4 99.787755c-13.061224 12.538776-19.330612 31.346939-16.195919 49.110204l24.032654 141.061225c6.269388 37.093878-8.359184 73.142857-38.661225 95.085714-30.302041 21.942857-69.485714 24.555102-102.4 7.314286L538.122449 836.440816c-16.195918-8.359184-35.526531-8.359184-51.722449 0l-126.955102 66.87347c-14.628571 7.314286-30.302041 10.971429-45.453061 10.971428z m162.481632-96.653061z" fill="#F2CB51" p-id="2041"></path> <text x="${len2}" y="670" fill="#fff" font-size="300">${item}</text> </svg>`
      // event.target.src = 'data:image/svg+xml;base64, ' + btoa(svg)
    },
    reportWindowSize() {
      const AppCanvas = this.$el.querySelector('#rootcanvas');
      if (AppCanvas.parentElement) {
        AppCanvas.parentElement.removeChild(AppCanvas);
      }
      this.startTagCanvas();
    },
    playHandler() {
      this.audioPlaying = true;
    },
    pauseHandler() {
      this.audioPlaying = false;
    },
    playAudio(type) {
      if (type) {
        this.$el.querySelector('#audiobg').play();
      } else {
        this.$el.querySelector('#audiobg').pause();
      }
    },
    loadAudio() {
      this.$el.querySelector('#audiobg').load();
      this.$nextTick(() => {
        this.$el.querySelector('#audiobg').play();
      });
    },
    getPhoto() {
      database.getAll(DB_STORE_NAME).then(res => {
        if (res && res.length > 0) {
          this.$store.commit('setPhotos', res);
        }
      });
    },
    speed() {
      return [0.1 * Math.random() + 0.01, -(0.1 * Math.random() + 0.01)];
    },
    createCanvas() {
      const canvas = document.createElement('canvas');
      canvas.width = document.body.offsetWidth;
      canvas.height = document.body.offsetHeight;
      canvas.id = 'rootcanvas';
      this.$el.querySelector('#main').appendChild(canvas);
    },
    startTagCanvas() {
      this.createCanvas();
      const { speed } = this;
      window.TagCanvas.Start('rootcanvas', 'tags', {
        textColour: null,
        initial: speed(),
        dragControl: 1,
        textHeight: 20,
        noSelect: true,
        lock: 'xy'
      });
    },
    reloadTagCanvas() {
      window.TagCanvas.Reload('rootcanvas');
    },
    closeRes() {
      this.showRes = false;
    },
    toggle(form) {
      const { speed, config } = this;
      if (this.running) {
        this.audioSrc = bgaudio;
        this.loadAudio();

        window.TagCanvas.SetSpeed('rootcanvas', speed());
        this.showRes = true;
        this.running = !this.running;
        this.$nextTick(() => {
          this.reloadTagCanvas();
        });
      } else {
        this.showRes = false;
        if (!form) {
          return;
        }

        this.audioSrc = beginaudio;
        this.loadAudio();

        const { number } = config;
        const { category, mode, qty, remain, allin } = form;
        let num = 1;
        if (mode === 1 || mode === 5) {
          num = mode;
        } else if (mode === 0) {
          num = remain;
        } else if (mode === 99) {
          num = qty;
        }
        const resArr = luckydrawHandler(
          number,
          allin ? [] : this.allresult,
          num
        );
        this.resArr = resArr;

        this.category = category;
        if (!this.result[category]) {
          this.$set(this.result, category, []);
        }
        const oldRes = this.result[category] || [];
        const data = Object.assign({}, this.result, {
          [category]: oldRes.concat(resArr)
        });
        this.result = data;
        window.TagCanvas.SetSpeed('rootcanvas', [1, 1]);
        this.running = !this.running;

        if (this.running) {
          this.getPhoto_photo_();
        }
      }
    },
    getPhoto_photo_() {
      var tag = getData('photo_');
      // console.log('tag___', tag)
      if (!tag || tag.length == 0) return '';
      for (let index = 0; index < tag.length; index++) {
        if (tag[index].id === this.category) {
          this.ppfile = tag[index].url;
          this.ppText = tag[index].text;
          break;
        }
      }
      return '';
    }
  }
};
</script>
<style lang="scss">
// #text_ {
// }

#root {
  height: 100%;
  position: relative;
  background-image: url('./assets/2022.png');
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #121936;

  .mask {
    -webkit-filter: blur(5px);
    filter: blur(5px);
  }

  header {
    height: 50px;
    line-height: 50px;
    position: relative;

    .el-button {
      position: absolute;
      top: 17px;
      padding: 0;
      z-index: 9999;

      &.con {
        right: 20px;
      }

      &.res {
        right: 100px;
      }
    }
  }

  .logo {
    position: absolute;
    left: 11%;
    top: 15%;
  }

  .audio {
    position: absolute;
    top: 100px;
    right: 30px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #fff;
    border-radius: 50%;
    padding: 0;
    text-align: center;

    .iconfont {
      position: relative;
      left: 1px;
    }
  }

  .copy-right {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #ccc;
    font-size: 12px;
  }

  .bounce-enter-active {
    animation: bounce-in 1.5s;
  }

  .bounce-leave-active {
    animation: bounce-in 0s reverse;
  }
}

#main {
  height: 100%;
}

#resbox {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1280px;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;

  p {
    // #D6EFF0 rgb(214 239 240)
    text-shadow: 5px 3px 9px #d6eff0;
    color: #fcff3b;
    font-size: 50px;
    line-height: 120px;
    margin-bottom: 28px;
  }

  .container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .itemres {
    background: #fff;
    width: 150px;
    height: 150px;
    line-height: 150px;
    border-radius: 50%;
    border: 1px solid #ccc;
    line-height: 160px;
    font-weight: bold;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    text-align: center;

    .cont {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 62px;
    }

    // 这是抽奖结束后，获奖结果左下角的序号
    //   &.numberOver::before {
    //     content: attr(data-id);
    //     width: 30px;
    //     height: 22px;
    //     line-height: 22px;
    //     background-color: #fff;
    //     position: absolute;
    //     bottom: 0;
    //     left: 0;
    //     font-size: 14px;
    //     // border-radius: 50%;
    //     z-index: 1;
    //   }
  }
}
</style>
